import { createStyles } from '@mantine/core';
import type { TablerIconsProps } from '@tabler/icons-react';
import { IconStarFilled as BaseIconStarFilled } from '@tabler/icons-react';

const useStyles = createStyles((theme, { color }: { color?: string }) => ({
  icon: {
    '& path': {
      fill: color,
    },
  },
}));

export function IconStarFilled({ color, className, ...rest }: TablerIconsProps) {
  const { classes, cx } = useStyles({ color });
  return <BaseIconStarFilled {...rest} className={cx(classes.icon, className)} />;
}
